import WorldBorder from "./world-border";

class CubicWorld extends WorldBorder {
    constructor(centerPosition, centerOrientation, size) {
        super();

        this.centerPosition = centerPosition;
        this.centerOrientation = centerOrientation;
        this.inverseOrientation = centerOrientation.clone().normalize().invert();
        this.size = size - this.borderOffset;
    }

    limitToBorder(position) {
        this.distance.subVectors(position, this.centerPosition);
        this.distance.applyQuaternion(this.inverseOrientation);
        this.distance.x = Math.min(this.distance.x, this.size);
        this.distance.x = Math.max(this.distance.x, -this.size);

        this.distance.y = Math.min(this.distance.y, this.size);
        this.distance.y = Math.max(this.distance.y, -this.size);

        this.distance.z = Math.min(this.distance.z, this.size);
        this.distance.z = Math.max(this.distance.z, -this.size);
        this.distance.applyQuaternion(this.centerOrientation);
        position.addVectors(this.centerPosition, this.distance);
    }
}

export default CubicWorld;
